export enum SignTypeEnum
{
	None = 0,
	ByBrowser = 1,
	ByLoadFile = 2
}
